import {Observable} from 'rxjs';
import {Message} from 'element-ui';
import {getCookie} from '@/utils/base.js';

let ws = undefined;
let count = 0;
const subs = {};
let timer = {};
let tempQueue = [];
const channel = 'supplier';

const initWebSocket = () => {
  clearInterval(timer); // ??
  const token = getCookie('token_supplier');
  const wsUrl = `${document.location.protocol.replace('http', 'ws')}//${document.location.host}/api/supplier/ws?token=${token}`;

  if (!ws && count < 5) {
    try {
      count += 1;
      ws = new WebSocket(wsUrl);
      ws.onclose = () => {
        ws = undefined;
        setTimeout(initWebSocket, 5000 * count);
      };

      ws.onopen = () => {
        if (tempQueue.length > 0 && ws.readyState === 1) {
          tempQueue.forEach((i, index) => {
            ws.send(i);
          });
          tempQueue = [];
        }
      };
      ws.onmessage = (msg) => {
        const data = JSON.parse(msg.data);
        if (data.type === 'error') {
          Message({
            message: data.message,
            type: "error"
          });
        }
        if (subs[data.requestId]) {
          if (data.type === 'complete') {
            subs[data.requestId].forEach((element) => {
              element.complete();
            });
          } else if (data.type === 'result') {
            subs[data.requestId].forEach((element) => {
              element.next(data);
            });
          }
        }
      };
    } catch (error) {
      setTimeout(initWebSocket, 5000 * count);
    }
  }
  timer = setInterval(() => {
    try {
      ws.send(JSON.stringify({type: 'ping'}));
    } catch (error) {
      console.error(error, '发送心跳错误');
    }
  }, 2000);
  return ws;
};

const getWebsocket = (id, topic, parameter) =>
  new Observable((subscriber) => {
    if (!subs[id]) {
      subs[id] = [];
    }
    subs[id].push({
      next: (val) => {
        subscriber.next(val);
      },
      complete: () => {
        subscriber.complete();
      },
    });
    const msg = JSON.stringify({channel, id, topic, parameter, type: 'sub'});
    const thisWs = initWebSocket();

    if (thisWs) {
      try {
        if (thisWs.readyState === 1) {
          thisWs.send(msg);
        } else {
          tempQueue.push(msg);
        }
      } catch (error) {
        initWebSocket();
        Message({
          message: 'websocket服务连接失败',
          type: "error"
        });
      }
    }

    return () => {
      const unsub = JSON.stringify({channel, id, topic, type: 'unsub'});
      delete subs[id];
      tempQueue = [];
      if (thisWs) {
        thisWs.send(unsub);
      }
    };
  });
export {getWebsocket, initWebSocket};



// WEBPACK FOOTER //
// ./src/utils/websocket/GlobalWebSocket.js